export default __webpack_public_path__ + "static/media/signinIcon.965268ca.svg";